import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';
import { getDayTemplate } from '@go-client/lib/api/template';
import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const FeedLog: React.FC<UserActionLog> = ({ body }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        let fields = {};

        if (body.templateId) {
          const template = await getDayTemplate(body.templateId);
          const templateFields = FieldsReplacer(template, logFields, [
            {
              from: 'name',
              to: 'templateId',
            },
          ]);

          fields = { ...fields, ...templateFields };
        }

        setLogFields({ ...logFields, ...fields });
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
